import React, { useEffect, useRef } from 'react';
import { Icon, StandAloneLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import useToggle from '../../../hooks/useToggle';
import Classes from './DescriptionButton.scss';

const DescriptionButton = () => {
  const { t } = useI18nContext();
  const myRef = useRef<HTMLDivElement | null>(null);
  const isMountingRef = useRef(false);
  const [isCollapsed, toggle] = useToggle(true, '[data-collapse-target="description"]', 'data-collapsed');

  useEffect(() => {
    if (!isCollapsed) {
      isMountingRef.current = true;
    }
    if (isCollapsed && isMountingRef.current) {
      myRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isCollapsed]);

  return (
    <div className={Classes.root} ref={myRef}>
      <StandAloneLink onClick={toggle}>
        {isCollapsed ? t('listing.description.expand') : t('listing.description.collapse')}
        <Icon name={isCollapsed ? 'arrow_down' : 'arrow_up'} color="signalInfoDefault" />
      </StandAloneLink>
    </div>
  );
};

export default DescriptionButton;
